/* eslint-disable */
import { useTranslation as useUiTranslation } from "react-i18next";
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Check, Store, PackageSearch, Send, ArrowUpRight } from "lucide-react";

export const DHD_PLAN_NAME = "شراكة مع dhd";

const FEATURES = [
  {
    key: "dhd_free_store",
    icon: Store,
    defaultLabel: "متجر FoorWeb مجاني",
  },
  {
    key: "dhd_abandoned_orders",
    icon: PackageSearch,
    defaultLabel: "الاطلاع على الطلبات المتروكة",
  },
  {
    key: "dhd_export_direct",
    icon: Send,
    defaultLabel: "التصدير المباشر نحو DHD",
  },
];

function DhdHeroMark() {
  const { t: uiT } = useUiTranslation();
  return (
    <div className="dhd-offer__mark" aria-hidden>
      <svg viewBox="0 0 140 64" className="dhd-offer__svg" fill="none">
        <rect
          className="dhd-offer__box"
          x="46"
          y="16"
          width="42"
          height="32"
          rx="5"
          fill="#FF6A00"
        />
        <path
          d="M48 18.5 L67 34 L86 18.5"
          stroke="#1a0a00"
          strokeWidth="2.4"
          strokeLinejoin="round"
          opacity="0.35"
        />

        <path
          className="dhd-offer__speed"
          d="M37 38 H23 M41 44 H27"
          stroke="#FF6A00"
          strokeWidth="2.8"
          strokeLinecap="round"
        />
      </svg>
      <div className="dhd-offer__wordmark">
        <span className="dhd-offer__dhd">DHD</span>
        <span className="dhd-offer__liv">{uiT("ship.delivery")}</span>
      </div>
    </div>
  );
}

export default function DhdPartnershipOffer({ subscription }) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  const isActive =
    subscription?.plan === DHD_PLAN_NAME ||
    subscription?.dhdPartnershipActive === true;

  return (
    <div className="dhd-offer" dir={isRTL ? "rtl" : "ltr"}>
      <style>{`
        .dhd-offer {
          position: relative;
          overflow: hidden;
          border-radius: 24px;
          border: 1px solid rgba(255, 106, 0, 0.28);
          background: linear-gradient(160deg, #0f0700 0%, #1f0d00 45%, #140900 100%);
          box-shadow:
            0 24px 60px rgba(255, 106, 0, 0.14),
            inset 0 1px 0 rgba(255, 255, 255, 0.06);
        }
        .dhd-offer__aurora {
          position: absolute;
          inset: -40%;
          background:
            radial-gradient(ellipse 40% 35% at 15% 20%, rgba(255,106,0,0.28), transparent 55%),
            radial-gradient(ellipse 35% 30% at 85% 80%, rgba(255,140,0,0.18), transparent 50%),
            radial-gradient(ellipse 25% 20% at 60% 10%, rgba(255,200,80,0.1), transparent 50%);
          animation: dhdAurora 8s ease-in-out infinite alternate;
          pointer-events: none;
        }
        @keyframes dhdAurora {
          from { transform: translate(0, 0) scale(1); }
          to { transform: translate(-3%, 2%) scale(1.05); }
        }
        .dhd-offer__grid {
          position: absolute;
          inset: 0;
          opacity: 0.12;
          background-image:
            linear-gradient(rgba(255,106,0,0.35) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,106,0,0.35) 1px, transparent 1px);
          background-size: 28px 28px;
          mask-image: radial-gradient(ellipse 70% 60% at 50% 40%, #000 20%, transparent 75%);
          pointer-events: none;
        }
        .dhd-offer__inner {
          position: relative;
          padding: 1.75rem 1.5rem 1.6rem;
        }
        @media (min-width: 640px) {
          .dhd-offer__inner { padding: 2rem 2rem 1.75rem; }
        }
        .dhd-offer__top {
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
          justify-content: space-between;
          gap: 1.25rem;
          margin-bottom: 1.5rem;
        }
        .dhd-offer__mark {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 0.35rem;
        }
        .dhd-offer__svg {
          width: 130px;
          height: 60px;
        }
        .dhd-offer__wing--l {
          transform-origin: 50px 32px;
          animation: dhdWingL 2.6s ease-in-out infinite;
        }
        .dhd-offer__wing--r {
          transform-origin: 90px 32px;
          animation: dhdWingR 2.6s ease-in-out infinite;
        }
        .dhd-offer__box {
          animation: dhdBox 2.6s ease-in-out infinite;
        }
        .dhd-offer__speed {
          animation: dhdSpeed 1.5s ease-in-out infinite;
        }
        @keyframes dhdWingL {
          0%, 100% { transform: rotate(0deg); }
          50% { transform: rotate(-10deg); }
        }
        @keyframes dhdWingR {
          0%, 100% { transform: rotate(0deg); }
          50% { transform: rotate(10deg); }
        }
        @keyframes dhdBox {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-2px); }
        }
        @keyframes dhdSpeed {
          0%, 100% { opacity: 0.3; transform: translateX(0); }
          50% { opacity: 1; transform: translateX(-6px); }
        }
        .dhd-offer__wordmark {
          display: flex;
          flex-direction: column;
          gap: 0.1rem;
        }
        .dhd-offer__dhd {
          font-size: 2rem;
          font-weight: 900;
          letter-spacing: 0.06em;
          color: #FF6A00;
          line-height: 1;
          animation: dhdGlow 3s ease-in-out infinite;
        }
        .dhd-offer__liv {
          font-size: 0.7rem;
          font-weight: 700;
          letter-spacing: 0.32em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.5);
        }
        @keyframes dhdGlow {
          0%, 100% { text-shadow: 0 0 0 transparent; }
          50% { text-shadow: 0 0 22px rgba(255,106,0,0.55); }
        }
        .dhd-offer__badge {
          display: inline-flex;
          align-items: center;
          gap: 0.35rem;
          margin-top: 0.85rem;
          padding: 0.3rem 0.7rem;
          border-radius: 999px;
          font-size: 0.7rem;
          font-weight: 800;
          letter-spacing: 0.04em;
          background: rgba(255, 106, 0, 0.15);
          color: #FF8A33;
          border: 1px solid rgba(255, 106, 0, 0.3);
        }
        .dhd-offer__title {
          margin: 0.65rem 0 0.35rem;
          font-size: 1.35rem;
          font-weight: 900;
          color: #fff;
          letter-spacing: -0.02em;
        }
        .dhd-offer__desc {
          margin: 0;
          max-width: 32rem;
          font-size: 0.9rem;
          line-height: 1.55;
          color: rgba(255,255,255,0.62);
        }
        .dhd-offer__toggle {
          display: inline-flex;
          align-items: center;
          gap: 0.45rem;
          padding: 0.7rem 1.2rem;
          border-radius: 14px;
          font-size: 0.85rem;
          font-weight: 800;
          border: none;
          cursor: pointer;
          transition: transform 0.12s ease, background 0.15s ease, box-shadow 0.15s ease;
          white-space: nowrap;
        }
        .dhd-offer__toggle:active:not(:disabled) {
          transform: scale(0.97);
        }
        .dhd-offer__toggle:disabled {
          opacity: 0.55;
          cursor: not-allowed;
        }
        .dhd-offer__toggle--on {
          background: #FF6A00;
          color: #1a0a00;
          box-shadow: 0 8px 24px rgba(255, 106, 0, 0.35);
        }
        .dhd-offer__toggle--on:hover:not(:disabled) {
          background: #ff7a1a;
        }
        .dhd-offer__toggle--off {
          background: rgba(255,255,255,0.08);
          color: rgba(255,255,255,0.9);
          border: 1px solid rgba(255,255,255,0.14);
        }
        .dhd-offer__toggle--off:hover:not(:disabled) {
          background: rgba(255,255,255,0.12);
        }
        .dhd-offer__features {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 0.75rem;
        }
        .dhd-offer__feature {
          position: relative;
          display: flex;
          align-items: flex-start;
          gap: 0.75rem;
          padding: 1rem 1.05rem;
          border-radius: 16px;
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255, 106, 0, 0.16);
          transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;
        }
        .dhd-offer__feature:hover {
          border-color: rgba(255, 106, 0, 0.4);
          background: rgba(255, 106, 0, 0.06);
          transform: translateY(-2px);
        }
        .dhd-offer__feature-icon {
          width: 38px;
          height: 38px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(255, 106, 0, 0.15);
          color: #FF6A00;
          flex-shrink: 0;
        }
        .dhd-offer__feature-text {
          font-size: 0.88rem;
          font-weight: 700;
          color: rgba(255,255,255,0.92);
          line-height: 1.4;
          padding-top: 0.35rem;
        }

        .dhd-offer__manage {
          display: inline-flex;
          align-items: center;
          gap: 0.45rem;
          padding: 0.7rem 1.25rem;
          border-radius: 14px;
          font-size: 0.875rem;
          font-weight: 800;
          background: #FF6A00;
          color: #1a0a00;
          text-decoration: none;
          box-shadow: 0 8px 24px rgba(255, 106, 0, 0.3);
          transition: background 0.15s ease, transform 0.12s ease;
          flex-shrink: 0;
          align-self: flex-start;
          margin-top: 0.35rem;
        }
        .dhd-offer__manage:hover {
          background: #ff7a1a;
          transform: translateY(-1px);
        }
        .dhd-offer__manage:visited,
        .dhd-offer__manage:active,
        .dhd-offer__manage:focus {
          color: #1a0a00 !important;
          background: #FF6A00;
          outline: none;
          -webkit-tap-highlight-color: transparent;
        }
        .dhd-offer__manage:active {
          background: #e55f00;
          transform: scale(0.98);
        }
        .dhd-offer__foot-row {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          gap: 0.75rem;
          margin-top: 1.25rem;
        }
        .dhd-offer__foot {
          display: flex;
          align-items: center;
          gap: 0.45rem;
          margin-top: 1.25rem;
          font-size: 0.78rem;
          font-weight: 700;
          color: rgba(255,255,255,0.45);
        }
        .dhd-offer__dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #64748b;
        }
        .dhd-offer__dot.is-on {
          background: #22c55e;
          box-shadow: 0 0 10px rgba(34, 197, 94, 0.7);
          animation: dhdDot 1.8s ease-in-out infinite;
        }
        @keyframes dhdDot {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.55; }
        }
      `}</style>

      <div className="dhd-offer__aurora" />
      <div className="dhd-offer__grid" />

      <div className="dhd-offer__inner">
        <div className="dhd-offer__top">
          <div>
            <DhdHeroMark />
            <div className="dhd-offer__badge">
              <Check size={12} strokeWidth={3} />
              {t("specialOfferPage.dhdPartner.acceptedBadge", {
                defaultValue: "تم قبول طلبك",
              })}
            </div>
            <h2 className="dhd-offer__title">
              {t("SubscriptionSettings.plans.dhd_partnership.name", {
                defaultValue: "شراكة مع DHD",
              })}
            </h2>
            <p className="dhd-offer__desc">
              {t("SubscriptionSettings.plans.dhd_partnership.desc", {
                defaultValue:
                  "استفد من متجر FoorWeb مجاناً، تتبع الطلبات المتروكة، والتصدير المباشر نحو DHD.",
              })}
            </p>
          </div>

          <Link to="/subscription" className="dhd-offer__manage">
            {t("SubscriptionSettings.dhd_partnership.manage", {
              defaultValue: "إدارة العرض",
            })}
            <ArrowUpRight size={16} />
          </Link>
        </div>

        <div className="dhd-offer__features">
          {FEATURES.map(({ key, icon: Icon, defaultLabel }) => (
            <div key={key} className="dhd-offer__feature">
              <div className="dhd-offer__feature-icon">
                <Icon size={18} strokeWidth={2.25} />
              </div>
              <div className="dhd-offer__feature-text">
                {t(`SubscriptionSettings.plans.features.${key}`, {
                  defaultValue: defaultLabel,
                })}
              </div>
            </div>
          ))}
        </div>

        <div className="dhd-offer__foot">
          <span className={`dhd-offer__dot ${isActive ? "is-on" : ""}`} />
          {isActive
            ? t("SubscriptionSettings.dhd_partnership.status_active", {
                defaultValue: "العرض مفعّل — خطتك الحالية هي شراكة مع DHD",
              })
            : t("SubscriptionSettings.dhd_partnership.status_inactive", {
                defaultValue: "العرض متاح — يمكنك تفعيله من صفحة الاشتراك",
              })}
        </div>
      </div>
    </div>
  );
}
